import { useClientContext } from "@hooks/index";
import { useQuery } from "@tanstack/react-query";
import { getNegExecution } from "./index";

export const useGetNegExecution = (enabled = true) => {
  const customFetch = useClientContext();

  return useQuery({
    queryKey: ["neg-execution"],
    retry: false,
    refetchInterval: 60000,
    refetchIntervalInBackground: false,
    queryFn: getNegExecution(customFetch),
    enabled,
  });
};
